window.custom_theme = window.custom_theme || {};

  // Early scroll restoration - run immediately with iOS fix
  (function() {
    try {
      const savedState = sessionStorage.getItem('plpState');
      if (savedState) {
        const state = JSON.parse(savedState);
        const currentPage = new URLSearchParams(window.location.search).get('page');
        const isFirstPage = !currentPage || currentPage === '1';
        
        // Only restore scroll position if we're not on the first page
        if (state.scrollPosition && state.scrollPosition > 0 && !isFirstPage) {
          // iOS fix: Force a repaint before restoring scroll
          document.documentElement.style.display = 'none';
          document.documentElement.offsetHeight; // Trigger reflow
          document.documentElement.style.display = '';
          
          // Restore scroll position immediately
          window.scrollTo(0, state.scrollPosition);
        }
      }
    } catch (error) {
      console.warn('Could not perform early scroll restoration:', error);
    }
  })();

  // --- NEW FIX: Centralized cleanup for images and sliders ---
  custom_theme.processInjectedProduct = function(item) {
    // 0. Ensure bundle/single classes for Load more (from data-product-template-suffix)
    if (item && item.classList && item.classList.contains('product-item')) {
      var suffix = (item.getAttribute('data-product-template-suffix') || '').toLowerCase();
      if (suffix.indexOf('bundle') !== -1) {
        item.classList.add('product-item--bundle', 'bundle-product-item');
      } else {
        item.classList.remove('product-item--bundle', 'bundle-product-item');
      }
    }

    // 1. Fix Lazy Loading & Hover Images
    const imgs = item.querySelectorAll('img');
    imgs.forEach(img => {
      // Force lazy-loaded images to load immediately
      if (img.dataset.src && !img.src) img.src = img.dataset.src;
      if (img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.sizes && !img.sizes) img.sizes = img.dataset.sizes;

      const removeIsLoading = () => {
        if (img.classList.contains('is-loading')) img.classList.remove('is-loading');
        if (img.parentElement && img.parentElement.classList.contains('is-loading')) {
          img.parentElement.classList.remove('is-loading');
        }
      };
      
      if (img.complete) {
        removeIsLoading();
      } else {
        img.addEventListener('load', removeIsLoading, { once: true });
      }
    });

    // 2. Clean up dead Flickity sliders (so the theme can rebuild them)
    const viewports = item.querySelectorAll('.flickity-viewport');
    if (viewports.length > 0) {
      viewports.forEach(vp => {
        const slider = vp.querySelector('.flickity-slider');
        if (!slider || !slider.children.length) {
          vp.remove();
        } else {
          // Move children out of the dead slider and remove the viewport wrapper
          while (slider.firstChild) {
            vp.parentNode.insertBefore(slider.firstChild, vp);
          }
          vp.remove();
        }
      });
    }
  };
  // -----------------------------------------------------------

  function getCollectionGridShownCount(productsContainer) {
    if (!productsContainer) return 0;
    var directChildren = productsContainer.children.length;
    var gridItems = productsContainer.querySelectorAll('.grid-item').length;
    return Math.max(directChildren, gridItems);
  }

  function updateLoadMoreCountFromDom() {
    var countEl = document.querySelector('.products_count--load-more');
    if (!countEl || countEl.textContent.indexOf('Showing 0 of') === -1) return;
    var productsContainer = document.querySelector('#CollectionLoop');
    var block = document.querySelector('.collection__load-more-block');
    if (!productsContainer || !block) return;
    var total = block.getAttribute('data-total-products');
    if (!total) return;
    var shown = getCollectionGridShownCount(productsContainer);
    countEl.textContent = 'Showing ' + shown + ' of ' + total + ' products';
  }

  document.addEventListener('DOMContentLoaded', function () {
    custom_theme.initSoldOutSort();
    // Fix initial "Showing 0 of X" after grid is ready (e.g. first 24 products)
    setTimeout(updateLoadMoreCountFromDom, 100);
    // Listen for sorting changes
    custom_theme.listenForSortingChanges();
    // Initialize state restoration
    custom_theme.initStateRestoration();
  });
  
  let isLoading = false;
  let soldOutItems = [];
  let observer = null;
  let allProductsLoaded = false;
  
  // State preservation variables
  let plpState = {
    loadedProducts: [],
    scrollPosition: 0,
    currentPage: 1,
    nextUrl: '',
    soldOutItems: [],
    allProductsLoaded: false
  };
  
  custom_theme.listenForSortingChanges = function() {
    // Listen for sort selection changes
    const sortLinks = document.querySelectorAll('[data-sort-link]');
    if (sortLinks.length) {
      sortLinks.forEach(link => {
        link.addEventListener('click', function() {
          // Reset sold out items when sorting changes
          soldOutItems = [];
          allProductsLoaded = false;
          
          // Re-initialize after the AJAX completes (give it time to load)
          setTimeout(function() {
            custom_theme.initSoldOutSort();
          }, 1000); // Adjust timeout if needed
        });
      });
    }
    
    // Also watch for form submissions on sort form
    const sortForm = document.querySelector('form[data-collection-filters-form]');
    if (sortForm) {
      sortForm.addEventListener('submit', function() {
        soldOutItems = [];
        allProductsLoaded = false;
      });
    }
  };
  
  custom_theme.initSoldOutSort = function () {
    if (allProductsLoaded) return;
  
    const productsContainer = document.querySelector('#CollectionLoop');
    if (!productsContainer) return;
  
    custom_theme.extractAndRemoveSoldOut(productsContainer);
  
    if (observer) observer.disconnect();
    observer = new MutationObserver((mutations) => {
      if (!allProductsLoaded) {
        // Check if this is a sorting/filtering change
        let isSortingChange = false;
        mutations.forEach(mutation => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 5) {
            isSortingChange = true;
          }
        });
        
        if (isSortingChange) {
          // Major DOM change detected, likely a sort/filter operation
          soldOutItems = []; // Reset sold out items
          allProductsLoaded = false;
        }
        
        const container = document.querySelector('#CollectionLoop');
        if (container) {
          custom_theme.extractAndRemoveSoldOut(container);
        }
      }
    });
  
    observer.observe(productsContainer.parentNode, {
      childList: true,
      subtree: true
    });
  };
  
  custom_theme.extractAndRemoveSoldOut = function (container) {
    if (!container) return;
    const nextUrl = container.dataset.nextUrl;
    if (container.dataset.soldoutFinalized === 'true') return;
    const existingSoldOut = container.querySelectorAll('.grid-item.product-item--has-soldout');
  
    existingSoldOut.forEach(item => {
      const id = item.getAttribute('id');
      const alreadyStored = soldOutItems.find(stored => stored.getAttribute('id') === id);
  
      if (!alreadyStored) {
        soldOutItems.push(item.cloneNode(true));
      }
  
      item.remove();
    });
     if (!nextUrl) {
        // Disconnect observer to prevent infinite loop
        if (observer) observer.disconnect();

        // Remove any existing sold-out items from DOM (in case of re-filtering)
        const existingInDom = container.querySelectorAll('.product-item--has-soldout');
        existingInDom.forEach(item => item.remove());

        // Append all collected sold-out items at the end, avoiding duplicates
        const usedIds = new Set();
        soldOutItems.forEach(item => {
        const id = item.getAttribute('id');
        if (id && !usedIds.has(id)) {
            item.style.display = "flex";
            custom_theme.processInjectedProduct(item); // Process images/sliders
            container.appendChild(item);
            usedIds.add(id);
        }
        });
        container.dataset.soldoutFinalized = 'true';
    } else {
      container.dataset.soldoutFinalized = 'false';
    }
  };
  
  // State preservation functions
  custom_theme.savePLPState = function() {
    const productsContainer = document.querySelector('#CollectionLoop');
    if (!productsContainer) return;
    
    // Save current state with more accurate scroll position
    const currentPage = this.getCurrentPageFromUrl();
    const isFirstPage = currentPage === 1;
    
    plpState = {
      loadedProducts: Array.from(productsContainer.children).map(item => item.outerHTML),
      scrollPosition: isFirstPage ? 0 : Math.max(
        window.pageYOffset || 0,
        document.documentElement.scrollTop || 0,
        document.body.scrollTop || 0
      ),
      currentPage: currentPage,
      nextUrl: productsContainer.dataset.nextUrl || '',
      soldOutItems: soldOutItems.map(item => item.outerHTML),
      allProductsLoaded: allProductsLoaded,
      currentUrl: window.location.pathname + window.location.search.split('&page=')[0]
    };
    
    // Save to sessionStorage
    try {
      sessionStorage.setItem('plpState', JSON.stringify(plpState));
    } catch (error) {
      console.warn('Could not save PLP state:', error);
    }
  };
  
  custom_theme.getCurrentPageFromUrl = function() {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');
    return page ? parseInt(page) : 1;
  };
  
  // iOS detection helper
  custom_theme.isIOS = function() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };
  
  custom_theme.restorePLPState = function() {
    try {
      const savedState = sessionStorage.getItem('plpState');
      if (!savedState) return false;
      
      const state = JSON.parse(savedState);
      const productsContainer = document.querySelector('#CollectionLoop');
      if (!productsContainer) return false;
      
      // Check if we're on the same collection page
      const currentUrl = window.location.pathname + window.location.search.split('&page=')[0];
      const savedUrl = state.currentUrl;
      
      if (savedUrl && currentUrl !== savedUrl) {
        // Different collection, clear saved state
        sessionStorage.removeItem('plpState');
        return false;
      }
      
      // Restore state
      if (state.loadedProducts && state.loadedProducts.length > 0) {
        // Clear existing products
        productsContainer.innerHTML = '';
        
        // Restore loaded products
        state.loadedProducts.forEach(productHtml => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = productHtml;
          const productElement = tempDiv.firstElementChild;
          if (productElement) {
            custom_theme.processInjectedProduct(productElement); // Process images/sliders
            productsContainer.appendChild(productElement);
          }
        });
        
        // Trigger resize to wake up theme scripts (sliders/lazyload)
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (typeof window.lazySizes !== 'undefined') window.lazySizes.init();
        }, 100);

        // Restore sold out items
        if (state.soldOutItems && state.soldOutItems.length > 0) {
          soldOutItems = state.soldOutItems.map(itemHtml => {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = itemHtml;
            return tempDiv.firstElementChild;
          }).filter(item => item);
        }
        
        // Restore other state
        allProductsLoaded = state.allProductsLoaded || false;
        if (productsContainer.dataset) {
          productsContainer.dataset.nextUrl = state.nextUrl || '';
        }
        
        // Update load more button visibility
        const loadMoreBtn = document.querySelector('.load-more_btn');
        if (loadMoreBtn) {
          if (allProductsLoaded) {
            loadMoreBtn.style.display = 'none';
          } else {
            loadMoreBtn.style.display = 'block';
            loadMoreBtn.textContent = 'Load more';
          }
        }
        
        // Restore scroll position with iOS-specific handling
        const scrollPosition = state.scrollPosition || 0;
        const currentPage = this.getCurrentPageFromUrl();
        const isFirstPage = currentPage === 1;
        
        // Only restore scroll position if we're not on the first page
        if (scrollPosition > 0 && !isFirstPage) {
          const isIOS = this.isIOS();
          
          if (isIOS) {
            // iOS-specific scroll restoration
            // Wait for images to load and DOM to be fully painted
            const restoreScroll = () => {
              // Force a repaint
              document.body.style.overflow = 'hidden';
              requestAnimationFrame(() => {
                document.body.style.overflow = '';
                
                // Scroll restoration
                window.scrollTo({
                  top: scrollPosition,
                  behavior: 'instant'
                });
                
                // Backup scroll restoration after a delay
                setTimeout(() => {
                  if (Math.abs(window.pageYOffset - scrollPosition) > 50) {
                    window.scrollTo(0, scrollPosition);
                  }
                }, 100);
              });
            };
            
            // Wait for images to load
            const images = productsContainer.querySelectorAll('img');
            if (images.length > 0) {
              let loadedCount = 0;
              const checkAllLoaded = () => {
                loadedCount++;
                if (loadedCount >= Math.min(images.length, 10)) { // Wait for first 10 images
                  restoreScroll();
                }
              };
              
              images.forEach((img, index) => {
                if (index < 10) { // Only wait for first 10 images
                  if (img.complete) {
                    checkAllLoaded();
                  } else {
                    img.addEventListener('load', checkAllLoaded, { once: true });
                    img.addEventListener('error', checkAllLoaded, { once: true });
                  }
                }
              });
              
              // Fallback timeout
              setTimeout(restoreScroll, 500);
            } else {
              restoreScroll();
            }
          } else {
            // Non-iOS scroll restoration (original code)
            if (window.scrollTo) {
              window.scrollTo({
                top: scrollPosition,
                behavior: 'instant'
              });
            }
            
            if (window.pageYOffset !== scrollPosition) {
              window.pageYOffset = scrollPosition;
              document.documentElement.scrollTop = scrollPosition;
              document.body.scrollTop = scrollPosition;
            }
          }
        }
        
        return true;
      }
    } catch (error) {
      console.warn('Could not restore PLP state:', error);
      sessionStorage.removeItem('plpState');
    }
    return false;
  };
  
  custom_theme.initStateRestoration = function() {
    // Check if we should restore state (user came back from product page)
    const shouldRestore = this.restorePLPState();
    
    if (shouldRestore) {
      // State was restored, reinitialize observers
      setTimeout(() => {
        this.initSoldOutSort();
      }, 200);
    }
  };
  
  // Listen for product link clicks to save state before navigation
  document.addEventListener('click', function(e) {
    const productLink = e.target.closest('a[href*="/products/"]');
    if (productLink) {
      custom_theme.savePLPState();
    }
  });
  
  // Listen for browser back/forward navigation
  window.addEventListener('popstate', function() {
    // Small delay to ensure page is loaded
    setTimeout(() => {
      if (document.querySelector('#CollectionLoop')) {
        custom_theme.restorePLPState();
      }
    }, 50);
  });
  
  // iOS-specific: Handle page visibility changes
  if (custom_theme.isIOS()) {
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        // Page became visible, ensure scroll position is correct
        const savedState = sessionStorage.getItem('plpState');
        if (savedState) {
          try {
            const state = JSON.parse(savedState);
            const currentPage = custom_theme.getCurrentPageFromUrl();
            const isFirstPage = currentPage === 1;
            
            if (state.scrollPosition && state.scrollPosition > 0 && !isFirstPage) {
              setTimeout(() => {
                window.scrollTo(0, state.scrollPosition);
              }, 100);
            }
          } catch (error) {
            console.warn('Error handling visibility change:', error);
          }
        }
      }
    });
  }
  
  custom_theme.loadMoreProducts = function () {
    if (isLoading) return;
  
    const productsContainer = document.querySelector('#CollectionLoop');
    const loadMoreBtn = document.querySelector('.load-more_btn');
  
    if (!productsContainer || !loadMoreBtn) return;
  
    const nextUrl = productsContainer.dataset.nextUrl;
    if (!nextUrl) return;
  
    isLoading = true;
    loadMoreBtn.textContent = 'Loading...';
  
    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductsContainer = doc.querySelector('#CollectionLoop');
  
        if (!newProductsContainer) return;
  
        // Add new sold-out products to the array
        const newSoldOut = newProductsContainer.querySelectorAll('.grid-item.product-item--has-soldout');
        newSoldOut.forEach(item => {
          const id = item.getAttribute('id');
          if (id && !soldOutItems.find(stored => stored.getAttribute('id') === id)) {
            soldOutItems.push(item.cloneNode(true));
          }
        });
  
        // Append only available items
        const availableProducts = newProductsContainer.querySelectorAll('.grid-item.product-item:not(.product-item--has-soldout)');
        availableProducts.forEach(item => {
          custom_theme.processInjectedProduct(item); // Process images/sliders
          productsContainer.appendChild(item);
        });

        // Trigger resize to fix newly appended sliders
        setTimeout(() => window.dispatchEvent(new Event('resize')), 100);

        // Re-initialize Yotpo review widgets for newly loaded products
        setTimeout(() => {
         if (window.yotpoWidgetsContainer?.initWidgets) {
            window.yotpoWidgetsContainer.initWidgets();
         }
        }, 300);
  
        const updatedNextUrl = newProductsContainer.dataset.nextUrl;
        const updateBrowserUrl = (isLastPage = false) => {
          try {
            let currentPage;
            
            if (isLastPage) {
              // For the last page, get the page number from the nextUrl we just fetched
              const fetchedUrlObj = new URL(nextUrl, window.location.origin);
              const fetchedPageParam = fetchedUrlObj.searchParams.get('page');
              currentPage = fetchedPageParam ? parseInt(fetchedPageParam) : 2;
            } else {
              // For regular pages, calculate from updatedNextUrl
              const nextUrlObj = new URL(updatedNextUrl, window.location.origin);
              const nextPageParam = nextUrlObj.searchParams.get('page');
              currentPage = nextPageParam ? parseInt(nextPageParam) - 1 : 2;
            }
            
            if (currentPage > 1) {
              // Get current URL
              const currentUrl = new URL(window.location);
              
              // Check if page parameter exists and update/add it
              currentUrl.searchParams.set('page', currentPage.toString());
              
              // Update browser URL without reloading
              window.history.replaceState({}, '', currentUrl.toString());
            }
          } catch (error) {
            console.warn('Error updating URL:', error);
          }
        };
        if (updatedNextUrl) {
          productsContainer.dataset.nextUrl = updatedNextUrl;
          productsContainer.closest('.grid-outer').querySelector('.wrapper .custom-next-url').setAttribute('href',updatedNextUrl);
          loadMoreBtn.textContent = 'Load more';
          updateBrowserUrl(false);
          var countEl = document.querySelector('.products_count--load-more');
          var block = document.querySelector('.collection__load-more-block');
          var total = block && block.getAttribute('data-total-products');
          if (countEl && total) {
            var shown = getCollectionGridShownCount(productsContainer);
            countEl.textContent = 'Showing ' + shown + ' of ' + total + ' products';
          }
        } else {
          loadMoreBtn.style.display = 'none';
          allProductsLoaded = true;
          var countEl = document.querySelector('.products_count--load-more');
          var block = document.querySelector('.collection__load-more-block');
          var total = block && block.getAttribute('data-total-products');
          if (countEl && total) {
            var shown = getCollectionGridShownCount(productsContainer);
            countEl.textContent = 'Showing ' + shown + ' of ' + total + ' products';
          }
  
          if (observer) observer.disconnect();
  
          // Remove any existing sold-out items from DOM
          const existingSoldOut = productsContainer.querySelectorAll('.product-item--has-soldout');
          existingSoldOut.forEach(item => item.remove());
  
          // Append all collected sold-out items
          const usedIds = new Set();
          soldOutItems.forEach(item => {
            const id = item.getAttribute('id');
            if (id && !usedIds.has(id)) {
              item.style.display = "flex"; 
              custom_theme.processInjectedProduct(item); // Process images/sliders
              productsContainer.appendChild(item);
              usedIds.add(id);
            }
          });
          updateBrowserUrl(true);
        }
        
        // Save state after loading more products
        custom_theme.savePLPState();
      })
      .catch(err => {
        console.error('Error fetching more products:', err);
      })
      .finally(() => {
        isLoading = false;
      });
  };
  
  // Handle Load More button click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.load-more_btn');
    if (btn) {
      e.preventDefault();
      custom_theme.loadMoreProducts();
    }
  });
  
  // Create a global function to update when sorting changes
  document.addEventListener('sort:updated', function() {
    soldOutItems = [];
    allProductsLoaded = false;
    const productsContainer = document.querySelector('#CollectionLoop');
    if (productsContainer) productsContainer.dataset.soldoutFinalized = 'false';
    setTimeout(function() {
      custom_theme.initSoldOutSort();
      // Re-initialize Yotpo review widgets after sorting (using robust method)
      setTimeout(() => {
        if (typeof initYotpoWidgets !== 'undefined') {
          initYotpoWidgets();
        }
      }, 500);
    }, 500);
  });
  document.addEventListener('click', function (e) {
    const filter_input  = e.target.closest('.filter-group input');
    const filter_select  = e.target.closest('.filter-group select');
    const active_filter = e.target.closest('.collection__active__filters .active__filters__remove');
    if (filter_input || filter_select || active_filter ) {
      const productsContainer = document.querySelector('#CollectionLoop');
      if (productsContainer) productsContainer.dataset.soldoutFinalized = 'false';
      setTimeout(function() {
        custom_theme.initSoldOutSort();
        }, 500);
    }
});
// Dedicated MutationObserver to handle post-filtering sold-out sorting
(function() {
  let filterObserver = null;
  let debounceTimer = null;
  let filterLoadingObserver = null;

  function initYotpoWidgets() {
    // Try multiple methods to initialize Yotpo widgets
    if (window.yotpoWidgetsContainer?.initWidgets) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }

  function observeProductGridLoading() {
    const productsContainer = document.querySelector('[data-products-grid]');
    if (!productsContainer) return;

    if (filterLoadingObserver) filterLoadingObserver.disconnect();

    filterLoadingObserver = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        // Watch for removal of is-loading class (filter AJAX complete)
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasLoading = productsContainer.classList.contains('is-loading');
          if (!hasLoading) {
            // Filter AJAX completed, initialize Yotpo after DOM settles
            setTimeout(() => {
              initYotpoWidgets();
            }, 500);
          }
        }
      });
    });

    filterLoadingObserver.observe(productsContainer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function observeProductGrid() {
    const productsContainer = document.querySelector('#CollectionLoop');
    if (!productsContainer) return;

    if (filterObserver) filterObserver.disconnect();

    filterObserver = new MutationObserver((mutationsList) => {
      // Debounce: wait 100ms after the last DOM change before running logic
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // Always extract and remove sold-out products
       const nextUrl = productsContainer.dataset.nextUrl;
        if (!nextUrl) {
        custom_theme.extractAndRemoveSoldOut(productsContainer);
        } else {
        custom_theme.initSoldOutSort();
        }
      }, 100);
    });

    filterObserver.observe(productsContainer, {
      childList: true,
      subtree: false
    });
  }
   document.addEventListener('DOMContentLoaded', function() {
    observeProductGrid();
    observeProductGridLoading();
  });
  document.addEventListener('sort:updated', observeProductGrid);
  document.addEventListener('click', function(e) {
    if (e.target.closest('.load-more_btn')) {
      const productsContainer = document.querySelector('#CollectionLoop');
      if (productsContainer) productsContainer.dataset.soldoutFinalized = 'false';
      custom_theme.initSoldOutSort();
    }
  });
document.addEventListener('click', function (e) {
    const filter_input  = e.target.closest('.filter-group input');
    const filter_select  = e.target.closest('.filter-group select');
    const active_filter = e.target.closest('.collection__active__filters .active__filters__remove');
    if (filter_input || filter_select || active_filter ) {
      const productsContainer = document.querySelector('#CollectionLoop');
      if (productsContainer) productsContainer.dataset.soldoutFinalized = 'false';
      setTimeout(function() {
        custom_theme.initSoldOutSort();
        }, 500);
    }
});

  // Price filter: checkbox ranges – single select, submit form. Only include price params when set (empty params break other filters).
  // Theme's updatePrice only submits when it finds data-field-price-min/max (range slider), so we must trigger submit ourselves.
  var priceFilterIgnoringChange = false;
  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-price-range-option]')) return;
    if (priceFilterIgnoringChange) return;
    var wrapper = e.target.closest('[data-price-range-filter]');
    if (!wrapper) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var gteInput = wrapper.querySelector('[data-price-gte]');
    var lteInput = wrapper.querySelector('[data-price-lte]');
    var checkboxes = wrapper.querySelectorAll('[data-price-range-option]');
    if (e.target.checked) {
      priceFilterIgnoringChange = true;
      checkboxes.forEach(function(cb) {
        if (cb !== e.target) cb.checked = false;
      });
      setTimeout(function() { priceFilterIgnoringChange = false; }, 0);
      gteInput.value = e.target.getAttribute('data-price-gte');
      lteInput.value = e.target.getAttribute('data-price-lte');
      if (gteInput.dataset.paramNameGte) {
        gteInput.setAttribute('name', gteInput.dataset.paramNameGte);
      }
      if (lteInput.dataset.paramNameLte) {
        lteInput.setAttribute('name', lteInput.dataset.paramNameLte);
      }
    } else {
      gteInput.value = '';
      lteInput.value = '';
      gteInput.removeAttribute('name');
      lteInput.removeAttribute('name');
    }
    var form = wrapper.closest('form');
    if (form) {
      var filtersFormEl = form.closest('collection-filters-form');
      if (filtersFormEl && typeof filtersFormEl.submitForm === 'function') {
        filtersFormEl.submitForm(e);
      }
    }
  }, true);
  document.addEventListener('input', function(e) {
    if (!e.target.matches('[data-price-range-option]')) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }, true);

  // Sync price range checkboxes to match hidden inputs or URL. Update parent <li> classes so price filter looks active like other filters.
  // Normalize to pounds: values >= 1000 are treated as pence and divided by 100.
  function normalizePriceToPounds(val) {
    if (val === '' || val == null) return '';
    var num = parseFloat(String(val).trim(), 10);
    if (isNaN(num)) return '';
    if (num >= 1000) num = Math.floor(num / 100);
    return String(Math.round(num));
  }

  function getPriceFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var gte = params.get('filter.v.price.gte') || '';
    var lte = params.get('filter.v.price.lte') || '';
    if (gte === '' && lte === '') return { gte: '', lte: '' };
    return { gte: normalizePriceToPounds(gte), lte: normalizePriceToPounds(lte) };
  }

  function syncPriceFilterCheckboxes() {
    var fromUrl = getPriceFromUrl();
    var gte = fromUrl.gte;
    var lte = fromUrl.lte;
    document.querySelectorAll('[data-price-range-filter]').forEach(function(wrapper) {
      var gteInput = wrapper.querySelector('[data-price-gte]');
      var lteInput = wrapper.querySelector('[data-price-lte]');
      var gteVal = (gteInput && gteInput.value) ? (gteInput.value || '').trim() : '';
      var lteVal = (lteInput && lteInput.value) ? (lteInput.value || '').trim() : '';
      if (gteVal !== '' || lteVal !== '') {
        gte = normalizePriceToPounds(gteVal);
        lte = normalizePriceToPounds(lteVal);
      }
      if (gte === '' && lte === '') return;
      var checkboxes = wrapper.querySelectorAll('[data-price-range-option]');
      checkboxes.forEach(function(cb) {
        var cbGte = (cb.getAttribute('data-price-gte') || '').trim();
        var cbLte = (cb.getAttribute('data-price-lte') || '').trim();
        var cbGteNorm = normalizePriceToPounds(cbGte);
        var cbLteNorm = normalizePriceToPounds(cbLte);
        var isActive = (gte !== '' && lte !== '' && gte === cbGteNorm && lte === cbLteNorm);
        if (cb.checked !== isActive) cb.checked = isActive;
        var li = cb.closest('li.sidebar__item');
        if (li) {
          if (li.classList.contains('sidebar__item--active') !== isActive) {
            li.classList.toggle('sidebar__item--active', isActive);
            li.classList.toggle('link--remove', isActive);
            li.classList.toggle('link--add', !isActive);
          }
        }
      });
    });
  }

  var priceSyncTimeout;
  var priceSyncRaf;
  function runSyncOnce() {
    priceSyncRaf = requestAnimationFrame(function() {
      priceSyncRaf = null;
      syncPriceFilterCheckboxes();
    });
  }
  function runSyncSoon() {
    clearTimeout(priceSyncTimeout);
    if (priceSyncRaf) cancelAnimationFrame(priceSyncRaf);
    priceSyncTimeout = setTimeout(runSyncOnce, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncPriceFilterCheckboxes();
    });
  } else {
    syncPriceFilterCheckboxes();
  }
  // After theme replaces sidebar/grid via AJAX, sync once after DOM settles (debounced, single rAF)
  var sidebar = document.querySelector('[data-collection-sidebar]');
  if (sidebar) {
    var sidebarObserver = new MutationObserver(function() {
      runSyncSoon();
    });
    sidebarObserver.observe(sidebar, { childList: true, subtree: true });
  }
  var productsGrid = document.querySelector('[data-products-grid]');
  if (productsGrid) {
    var gridObserver = new MutationObserver(function() {
      runSyncSoon();
    });
    gridObserver.observe(productsGrid, { childList: true, subtree: true });
  }
  window.addEventListener('pageshow', function() {
    runSyncSoon();
  });

})();